// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".referenceContent[data-v-5d897b5c]{max-height:400px;overflow:auto}.reference[data-v-5d897b5c]{display:inline-block;cursor:pointer;color:#3d7eff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
